<template>
    <div class="row mb-2 mb-md-4">
        <div
            v-for="(zoneReassuranceEquipmentsItem, index) in zoneReassuranceEquipments.zoneReassuranceEquipmentsItem"
            :key="index"
            class="col-12 col-md-4 mt-1 mt-md-0"
        >
            <ob1-cards :with-composite-link="false" class="h-100 d-flex flex-column text-center p-1 p-lg-2">
                <h3 class="title mb-0">
                    {{ zoneReassuranceEquipmentsItem.title }}
                </h3>
                <p class="mb-0 mb-md-1">
                    <span v-html="zoneReassuranceEquipmentsItem.text" />
                </p>
                <ob1-liens
                    class="standard mt-auto mw-100"
                    :text="zoneReassuranceEquipmentsItem.linkLabel"
                    :href="zoneReassuranceEquipmentsItem.linkUrl"
                    :with-arrow="true"
                    :data-oevent-category="zoneReassuranceEquipmentsItem.tms.tagZone + (index + 1)"
                    :data-oevent-action="tagName(zoneReassuranceEquipmentsItem.linkLabel)"
                    :data-oevent-label="zoneReassuranceEquipmentsItem.linkUrl"
                />
            </ob1-cards>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        zoneReassuranceEquipments: {
            type: Object,
            required: true
        },
    },
    methods: {
        tagName(name) {
            return stripAccents(name).split(' ').join('-').replace('-&-', '-')
        },
    }
}
</script>

<style scoped lang="scss">
@import 'ob1_variables';
//Iso Prod
.title {
    font-size: 1.625rem;
    @media (max-width: #{map-get($grid-breakpoints, lg)}) {
        font-size: 1.25rem;
    }
}
</style>
